/* eslint-disable react/no-unused-prop-types */
import { colorsV4 } from '@tokenterminal/ui/theme/themeV4/colorsContract.css'
import { animated } from '../LoadingIndicator.css'
import type { CSSProperties } from 'react'

export enum ChartLoaderType {
  line,
  bar,
}

export type ChartLoadingIndicatorProps = {
  blinkInterval?: number
  style?: CSSProperties
  type?: ChartLoaderType
}

export const ChartLoadingIndicator = ({
  type = ChartLoaderType.line,
  ...props
}: ChartLoadingIndicatorProps) => {
  if (type === ChartLoaderType.line) {
    return <LineSkeleton {...props} />
  }

  return <BarSkeleton {...props} />
}

export function LineSkeleton({
  blinkInterval = 1500,
  style,
}: ChartLoadingIndicatorProps) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 327 229"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g mask="url(#mask0_363_63633)">
        <path
          opacity="0.1"
          d="M-121.632 144.018L-125 131.212V215.173H487V196.156L483.02 182.74L477.203 192.497L470.161 176.642L462.814 184.875L450.874 154.69L442.608 148.896L433.423 160.483H428.525L425.769 144.018L421.483 148.896L418.728 141.884L415.666 146.152L408.319 140.359L405.563 146.152H401.889L398.216 134.871L394.542 136.7L388.419 117.797L380.765 121.151L373.417 119.626L367.294 110.784L364.539 117.797L358.416 112.613L353.211 110.784L349.537 113.833L343.108 115.967L340.965 121.151L335.454 115.967L329.331 106.21L326.576 113.833L323.208 112.613L319.84 119.626L315.86 113.833L313.105 123.285L311.268 119.626L302.696 117.797L294.736 127.858L288.613 123.285L282.49 127.858L278.51 134.871L268.407 131.212L264.427 123.285L255.548 119.626L247.588 125.114L243.302 115.967L237.485 125.114L231.974 141.884L227.076 146.152L220.953 129.383L217.279 138.53L213.299 136.7L209.931 121.151L206.258 125.114L203.196 141.884L199.216 129.383L197.073 106.21L194.011 98.588H189.725L182.684 69.3176L179.316 83.6479L175.948 108.955H172.581L168.907 112.613L165.845 121.151L163.09 108.955L158.192 110.784L155.742 102.247L152.375 71.4519L149.007 66.8784L145.333 75.4156L140.435 77.8548L137.985 75.4156L135.23 71.4519L131.556 77.8548L127.576 96.4537L126.045 93.4047L120.841 91.8802L118.392 89.1361L114.105 98.588L111.35 83.6479L108.595 86.392L104.921 71.4519L99.4102 77.8548L94.5117 73.5862L88.3887 83.6479H84.1025L80.4287 69.3176L76.7549 71.4519L73.3872 69.3176L69.7133 62L66.9579 81.2087L62.6718 73.5862L60.8349 83.6479L53.4872 96.4537L49.5072 83.6479L46.4457 91.8802L43.078 89.1361L36.0365 123.285L32.3627 117.797H28.995L25.3211 110.784L14.6058 127.858L8.48273 125.114L5.42119 131.212L1.13504 133.347L-1.92648 131.212L-6.82494 140.359L-12.3357 165.056L-16.3157 156.214L-18.7649 148.896L-24.5818 151.641L-29.4803 141.884L-33.1541 136.7L-36.2156 140.359L-38.971 127.858L-41.7264 123.285L-46.3187 127.858L-50.2987 123.285L-53.9725 127.858L-56.4217 119.626L-59.4833 117.797L-63.1571 121.151L-66.8309 138.53L-73.5663 160.483H-77.2401L-80.3017 151.641L-87.3432 162.922L-94.0785 184.875L-97.4462 182.74L-100.508 172.069L-107.549 174.813L-111.223 168.41L-114.591 140.359L-118.265 148.896L-121.632 144.018Z"
          fill="url(#paint0_linear_363_63633)"
        />
        <path
          d="M-125 131.212L-121.632 144.018L-118.265 148.896L-114.591 140.359L-111.223 168.41L-107.549 174.813L-100.508 172.069L-97.4462 182.74L-94.0785 184.875L-87.3432 162.922L-80.3017 151.641L-77.2401 160.483H-73.5663L-66.8309 138.53L-63.1571 121.151L-59.4833 117.797L-56.4217 119.626L-53.9725 127.858L-50.2987 123.285L-46.3187 127.858L-41.7264 123.285L-38.971 127.858L-36.2156 140.359L-33.1541 136.7L-29.4803 141.884L-24.5818 151.641L-18.7649 148.896L-16.3157 156.214L-12.3357 165.056L-6.82493 140.359L-1.92648 131.212L1.13505 133.347L5.42119 131.212L8.48272 125.114L14.6058 127.858L25.3211 110.784L28.995 117.797H32.3627L36.0365 123.285L43.078 89.1361L46.4457 91.8802L49.5072 83.6479L53.4872 96.4537L60.8349 83.6479L62.6718 73.5862L66.9579 81.2087L69.7133 62L73.3872 69.3176L76.7548 71.4519L80.4287 69.3176L84.1025 83.6479H88.3887L94.5117 73.5862L99.4102 77.8548L104.921 71.4519L108.595 86.392L111.35 83.6479L114.106 98.588L118.392 89.1361L120.841 91.8802L126.045 93.4047L127.576 96.4537L131.556 77.8548L135.23 71.4519L137.985 75.4156L140.435 77.8548L145.333 75.4156L149.007 66.8784L152.375 71.4519L155.742 102.247L158.192 110.784L163.09 108.955L165.845 121.151L168.907 112.613L172.581 108.955H175.948L179.316 83.6479L182.684 69.3176L189.725 98.588H194.011L197.073 106.21L199.216 129.383L203.196 141.884L206.258 125.114L209.931 121.151L213.299 136.7L217.279 138.53L220.953 129.383L227.076 146.152L231.974 141.884L237.485 125.114L243.302 115.967L247.588 125.114L255.548 119.626L264.427 123.285L268.407 131.212L278.51 134.871L282.49 127.858L288.613 123.285L294.736 127.858L302.696 117.797L311.268 119.626L313.105 123.285L315.86 113.833L319.84 119.626L323.208 112.613L326.576 113.833L329.331 106.21L335.454 115.967L340.965 121.151L343.108 115.967L349.537 113.833L353.211 110.784L358.416 112.613L364.539 117.797L367.294 110.784L373.417 119.626L380.765 121.151L388.419 117.797L394.542 136.7L398.216 134.871L401.889 146.152H405.563L408.319 140.359L415.666 146.152L418.728 141.884L421.483 148.896L425.769 144.018L428.525 160.483H433.423L442.608 148.896L450.874 154.69L462.814 184.875L470.161 176.642L477.203 192.497L483.02 182.74L487 196.156"
          strokeWidth="1"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_363_63633"
          x1="181"
          y1="73.0644"
          x2="181"
          y2="215"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37363E" />
          <stop offset="1" stopColor="#37363E" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function BarSkeleton({
  blinkInterval = 1500,
  style,
}: ChartLoadingIndicatorProps) {
  return (
    <svg
      height="100%"
      width="100%"
      preserveAspectRatio="none"
      style={style}
      viewBox="0 0 327 229"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_417_64337)">
        <line
          x1="185.142"
          y1="115.266"
          x2="185.142"
          y2="74.9226"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="204.715"
          y1="115.266"
          x2="204.715"
          y2="71.0805"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="230.814"
          y1="115.266"
          x2="230.814"
          y2="80.0456"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="256.913"
          y1="115.266"
          x2="256.913"
          y2="76.2034"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="276.487"
          y1="115.266"
          x2="276.487"
          y2="72.3612"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="302.586"
          y1="115.266"
          x2="302.586"
          y2="55.4036"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="322.16"
          y1="115.266"
          x2="322.16"
          y2="79.2656"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="44.8255"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 9.97461 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="47.387"
          y2="-1"
          transform="matrix(-6.49075e-08 1 1 2.9437e-08 36.0732 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="51.2292"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 55.6475 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="80.7466"
          y1="162.974"
          x2="80.7466"
          y2="115.587"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="84.5282"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 107.845 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="80.0456"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 133.944 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="71.7209"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 140.469 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="15.03"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 166.567 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="211.24"
          y1="115.266"
          x2="211.24"
          y2="79.4052"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="237.339"
          y1="115.266"
          x2="237.339"
          y2="81.6981"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="263.438"
          y1="115.266"
          x2="263.438"
          y2="52.5099"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="283.012"
          y1="115.266"
          x2="283.012"
          y2="71.0805"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="309.111"
          y1="115.266"
          x2="309.111"
          y2="74.2823"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="42.2641"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 16.4995 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="46.1063"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 42.5986 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="55.7117"
          y2="-1"
          transform="matrix(-6.44674e-08 1 1 2.96379e-08 62.1724 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="86.9365"
          y1="139.205"
          x2="86.9365"
          y2="115.587"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="67.8787"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 94.7959 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="76.2034"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 114.37 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="64.6768"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 146.994 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="172.092"
          y1="115.266"
          x2="172.092"
          y2="85.9213"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="191.667"
          y1="115.266"
          x2="191.667"
          y2="72.3612"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="217.765"
          y1="115.266"
          x2="217.765"
          y2="83.8877"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="243.864"
          y1="115.266"
          x2="243.864"
          y2="80.6859"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="289.537"
          y1="115.266"
          x2="289.537"
          y2="73.6419"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="315.636"
          y1="115.266"
          x2="315.636"
          y2="63.3961"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="37.7815"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 23.0244 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="51.2292"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 49.123 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="60.1943"
          y2="-1"
          transform="matrix(-6.44674e-08 1 1 2.96379e-08 68.6973 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="97.3354"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 120.895 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="60.8347"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 153.518 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="178.617"
          y1="115.266"
          x2="178.617"
          y2="72.3227"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="198.191"
          y1="115.266"
          x2="198.191"
          y2="70.4401"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="224.29"
          y1="115.266"
          x2="224.29"
          y2="83.2474"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="250.389"
          y1="115.266"
          x2="250.389"
          y2="80.6859"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="269.963"
          y1="115.266"
          x2="269.963"
          y2="72.3612"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          x1="296.062"
          y1="115.266"
          x2="296.062"
          y2="73.6419"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="37.7815"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 3.4502 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="38.4219"
          y2="-1"
          transform="matrix(-6.95855e-08 1 1 2.74581e-08 29.5488 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="55.7117"
          y2="-1"
          transform="matrix(-6.49075e-08 1 1 2.9437e-08 75.2217 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="69.7998"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 101.321 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="94.1336"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 127.419 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
        <line
          y1="-1"
          x2="30.7758"
          y2="-1"
          transform="matrix(-6.46874e-08 1 1 2.95371e-08 160.043 115.587)"
          stroke={colorsV4.scale.neutral50Alpha}
          className={animated}
          style={{
            animationDuration: `${blinkInterval}ms`,
          }}
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}
